import {throttle} from 'lodash';
import {useCallback, useEffect, useRef, useState} from 'react';
import {useEscpacePress} from '@/hooks/helper';
import {Panorama} from '../Panorama';
import {GuideMarker} from './GuideMarker';

interface IProps {
  map: naver.maps.Map;
  onFinish?(): void;
}

export const StreetLayer = ({map, onFinish}: IProps) => {
  const ref = useRef<naver.maps.StreetLayer>();
  const evt = useRef<naver.maps.MapEventListener[]>([]);

  const [point, setPoint] = useState<naver.maps.LatLng>();
  const [onEscape, setOnEscape] = useState<boolean>(false);

  const [guidePosision, setGuidePosition] = useState<naver.maps.LatLng>();

  const onEscapePress = useCallback(() => {
    setOnEscape(true);
  }, []);

  const onPositionChanged = useCallback(
    (position: naver.maps.LatLng) => {
      map.setCenter(position);
    },
    [map]
  );

  const onClick = useCallback((e: {coord: naver.maps.LatLng}) => {
    if (ref.current?.getMap()) {
      setPoint(e.coord);
    }
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onMousemoveEvent = useCallback(
    throttle((e: {coord: naver.maps.LatLng}) => {
      setGuidePosition(e.coord);
    }, 50),
    []
  );

  useEscpacePress(onEscapePress);

  useEffect(() => {
    if (map) {
      const layer = new naver.maps.StreetLayer();

      layer.setMap(map);
      ref.current = layer;

      evt.current.push(naver.maps.Event.addListener(map, 'click', onClick));
      evt.current.push(
        naver.maps.Event.addListener(map, 'mousemove', onMousemoveEvent)
      );
    }

    return () => {
      ref.current?.setMap?.(null);

      if (evt.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        evt.current.forEach((event) => {
          naver.maps.Event.removeListener(event);
        });
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map]);

  useEffect(() => {
    if (onEscape) {
      if (point) {
        setOnEscape(false);
      } else {
        onFinish?.();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onEscape]);

  return (
    <>
      {point && (
        <Panorama
          position={point}
          onPositionChanged={onPositionChanged}
          onClose={() => setPoint(undefined)}
        />
      )}
      {guidePosision && <GuideMarker map={map} position={guidePosision} />}
    </>
  );
};
